module.exports = __webpack_public_path__ + "img/4.df66960c.jpg";